@if(!!service) {
    <div class="service-overview-item__view">
        <div class="service-overview-item__information">
            <div class="service-overview-item__information__header">
                <span
                    class="service-overview-item__information__header__title dynamic__text dynamic__text--bold">{{ service.name }}</span>
                <span class="service-overview-item__information__description dynamic__text--xs">{{service.description}}</span>
            </div>
            <app-service-inline-info class="service-overview-item__information__inline"></app-service-inline-info>
        </div>

        <dynamo-image
            class="service-overview-item__image"
            height="100%"
            backgroundSize="cover"
            source="{{environment.service_proxy}}attributes/get/preview/banner/{{service.id}}"
            [width]="commonService.isMobile() ? '100%' : '15rem'"
            dynamoImageSource>
        </dynamo-image>
    </div>
}
